var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Shape",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Comunications",
    transform: "translate(-64.000000, -320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconspace_Email-tick_54px",
    transform: "translate(64.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#E6F0FC",
    id: "Shape",
    r: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(11.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,1 L38,1 C39.1045695,1 40,1.8954305 40,3 L40,27 C40,28.1045695 39.1045695,29 38,29 L3,29 C1.8954305,29 1,28.1045695 1,27 L1,3 C1,1.8954305 1.8954305,1 3,1 Z",
    fill: "#FFFFFF",
    id: "Rectangle-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.021442,16.3221726 L1.81162776,3.60865516 C1.3011871,3.23157403 1,2.63461787 1,2 C1,0.8954305 1.8954305,1.77635684e-14 3,-3.55271368e-15 L38.6080007,-3.55271368e-15 C39.2426186,-3.55271368e-15 39.8395748,0.301187104 40.2166559,0.811627764 C40.8729758,1.70006348 40.6848087,2.9523353 39.796373,3.60865516 L22.5865587,16.3221726 C21.5270609,17.1048623 20.0809398,17.1048623 19.021442,16.3221726 Z M38.6080007,2 L3,2 L20.2098143,14.7135174 C20.5629802,14.974414 21.0450206,14.974414 21.3981865,14.7135174 L38.6080007,2 Z",
    fill: "#154E84",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L38,0 C39.6568542,-3.33066907e-16 41,1.34314575 41,3 L41,27 C41,28.6568542 39.6568542,30 38,30 L3,30 C1.34314575,30 3.33066907e-16,28.6568542 0,27 L0,3 C-1.66533454e-16,1.34314575 1.34314575,3.33066907e-16 3,0 Z M3,2 C2.44771525,2 2,2.44771525 2,3 L2,27 C2,27.5522847 2.44771525,28 3,28 L38,28 C38.5522847,28 39,27.5522847 39,27 L39,3 C39,2.44771525 38.5522847,2 38,2 L3,2 Z",
    fill: "#154E84",
    fillRule: "nonzero",
    id: "Rectangle-5-Copy-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,20.5 L11,20.5 C11.5522847,20.5 12,20.0522847 12,19.5 C12,18.9477153 11.5522847,18.5 11,18.5 L5,18.5 C4.44771525,18.5 4,18.9477153 4,19.5 C4,20.0522847 4.44771525,20.5 5,20.5 Z",
    fill: "#FFC200",
    fillRule: "nonzero",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,24.5 L18,24.5 C18.5522847,24.5 19,24.0522847 19,23.5 C19,22.9477153 18.5522847,22.5 18,22.5 L5,22.5 C4.44771525,22.5 4,22.9477153 4,23.5 C4,24.0522847 4.44771525,24.5 5,24.5 Z",
    fill: "#52ABE2",
    fillRule: "nonzero",
    id: "Rectangle-Copy-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(44.000000, 40.000000) rotate(-180.000000) translate(-44.000000, -40.000000) translate(33.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,11.5 C21,16.7467051 16.7467051,21 11.5,21 C6.25329488,21 2,16.7467051 2,11.5 C2,6.25329488 6.25329488,2 11.5,2 C16.7467051,2 21,6.25329488 21,11.5 Z",
    fill: "#FFFFFF",
    id: "Oval-176-Copy-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 1.12815164e-13,17.0751322 1.13931148e-13,11 C1.15047132e-13,4.92486775 4.92486775,-3.55271368e-15 11,0 C17.0751322,0 22,4.92486775 22,11 Z M19.9047619,11 C19.9047619,6.0820358 15.9179642,2.0952381 11,2.0952381 C6.0820358,2.0952381 2.0952381,6.0820358 2.0952381,11 C2.0952381,15.9179642 6.0820358,19.9047619 11,19.9047619 C15.9179642,19.9047619 19.9047619,15.9179642 19.9047619,11 Z",
    fill: "#154E84",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.168056,12.5548065 C13.4744084,13.0143352 14.0952778,13.138509 14.5548065,12.8321566 C15.0143352,12.5258041 15.138509,11.9049348 14.8321566,11.4454061 L12.8321566,8.44540608 C12.5258041,7.98587739 11.9049348,7.86170352 11.4454061,8.16805598 L5.44540608,12.168056 C4.98587739,12.4744084 4.86170352,13.0952778 5.16805598,13.5548065 C5.47440844,14.0143352 6.09527778,14.138509 6.55480647,13.8321566 L11.7227562,10.3868568 L13.168056,12.5548065 Z",
    fill: "#52ABE2",
    fillRule: "nonzero",
    id: "Path-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCheckIcon);
export default __webpack_public_path__ + "static/media/email_check_icon.763f0122f246034e4b413007004aad80.svg";
export { ForwardRef as ReactComponent };